<div class="sk-cms-form form-wap {{basic.style.type}} {{isPreview ? '': 'sk-component CUSTOMFORM'}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
    {{/if}}

    <div class="form-main customform-{{content.customFormId}} {{style.isShowTitle == '1' ? '' : 'u-pt20'}}">
            {{if !content.items || content.items.length == 0}}
            <% include('../common/nodata.art', {text: '表单尚未设置字段，',textB: '请到站内表单管理中设置此表单字段！'}) %>
            {{else}}
            <% include('../form/field.art', {items: content.items}) %>
            {{/if}}
        </div>
        <div class="form-button custom-button-{{content.customFormId}}" sk-style="{display: $data.isButtonShow ? 'block' : 'none'}">
            <div class="button-text {{style.button.styleType == 'default'?'medium':style.button.fontSize}}"
                 style="{{style.button.styleType == 'custom' ? 'color: '+style.button.color+'; background: url(\''+style.button.imgUrl+'\') '+style.button.backgroundColor : ''}}"
                 sk-event.click="customSave()" sk-class="$data.disabled ? 'disabled' : ''">
            {{content.buttonText}}
            </div>
        </div>
</div>